export const staticReportTypes = [
	{ value: "reviewReport", label: "Review" },
	{ value: "employeeReport", label: "Employee" },
	{ value: "goalReport", label: "Goal" },
	{ value: "surveyReport", label: "Survey" },
];

export const reportTypeLookup = {
	employeeReport: "Employee",
	reviewReport: "Review",
	goalReport: "Goal",
	surveyReport: "Survey",
};

export const defaultReportPageSize = 50;

export const maxReportPageSize = 200;

export const pageSizes = [25, 50, 100, 200];
